import { InjectionToken } from "@angular/core";

/**
 * Token for injecting the current application's name.
 */
export const APPLICATION_NAME = new InjectionToken<string>("APPLICATION_NAME");
